import { ProjectTask } from "./ProjectTask";

/**
 * Resposta de GET /ClientPortal/overview. Os campos por área vêm OMITIDOS (não null, não 0)
 * quando a pessoa não tem a área — por isso são opcionais. `undefined` = "não é para mostrar".
 */
export interface ClientPortalOverview {
  clientId: number;
  clientName?: string;
  // Projetos
  totalProjects?: number;
  activeProjects?: number;
  openTasks?: number;
  overdueTasks?: number;
  // Horas
  totalContractedHours?: number;
  totalWorkedHours?: number;
  // Financeiro
  billingPendingCount?: number;
  billingOpenAmount?: number;
  billingReceivedAmount?: number;
}

/** Resposta de GET /ClientPortal/areas — o que o usuário logado pode ver no portal. */
export interface ClientPortalAreas {
  podeVerChamados: boolean;
  podeVerProjetos: boolean;
  podeVerHoras: boolean;
  podeVerFinanceiro: boolean;
}

export interface ClientPortalProject {
  projectId: number;
  projectName: string;
  status: number;
  statusName: string;
  startDate?: string;
  estimatedEndDate?: string;
  contractedHours?: number;
  workedHours: number;
  totalTasks: number;
  doneTasks: number;
  overdueTasks: number;
}

export interface ClientPortalHoursMonth {
  year: number;
  month: number;
  label: string;
  hours: number;
}

export const BILLING_STATUS_LABELS: Record<number, string> = {
  1: "Pendente",
  2: "Faturado",
  3: "Recebido",
  4: "Cancelado",
  5: "Ordem de Serviço",
};

export interface ClientPortalTimesheetEntry {
  day: number;
  month: number;
  year: number;
  employeeName: string;
  projectName: string;
  hours: number;
  activity?: string | null;
}

export interface ClientPortalBilling {
  id: number;
  projectId?: number;
  projectName?: string;
  monthRef: number;
  yearRef: number;
  amount: number;
  status: number;
  statusName: string;
  invoiceNumber?: string;
  dtEmitted?: string;
  dtReceived?: string;
}

/**
 * Item de GET /ClientPortal/tasks: só os campos que o cliente pode ver, com os mesmos nomes de
 * `ProjectTask`. Ficam de fora responsáveis, horas, descrição, prioridade e dependências. O
 * TaskGantt só lê estes campos (mais os dados internos, que no portal vêm omitidos).
 */
export type ClientPortalTask = Pick<
  ProjectTask,
  | "id"
  | "projectId"
  | "parentTaskId"
  | "type"
  | "title"
  | "startDate"
  | "dueDate"
  | "statusName"
  | "statusCategory"
  | "orderIndex"
  | "isOverdue"
  | "scheduleState"
> & { projectName?: string };
